export const KEY_ADDRS = {
  CLAIMS_ESCROW: '0x501aCEA73C7f4E5fB6Bce5A53603DA611F6A854C',
  CPFARM: '0x501ACeb4D4C2CB7E4b07b53fbe644f3e51D25A3e',
  FARM_CONTROLLER: '0x501aCEDD1a697654d5F53514FF09eDECD3ca6D95',
  FARM_REWARDS: '0x501acEA5a5B21f863215385C1EDaA46eeB562328',
  POLICY_MANAGER: '0x501ace5E9f058bB2E851675BB3fA104Da6E3A22C',
  RISK_MANAGER: '0x501ACe9eE0AB4D2D4204Bcf3bE6eE13Fd6337804',
  SOLACE: '0x501acE9c35E60f03A2af4d484f49F9B1EFde9f40',
  XSOLACE_V1: '0x501AcE5aC3Af20F49D53242B6D208f3B91cfc411',
  XSOLACE: '0x501ACe802447B1Ed4Aae36EA830BFBde19afbbF9',
  XSLOCKER: '0x501Ace47c5b0C2099C4464f681c3fa2ECD3146C1',
  STAKING_REWARDS: '0x501ace3D42f9c8723B108D4fBE29989060a91411',
  XSOLACE_MIGRATOR: '0x501aCe6Ce61D1fFecdade5BB04539809Bc301FeE',
  VAULT: '0x501AcEe83a6f269B77c167c6701843D454E2EFA0',
  BOND_DEPO: '0x501ACe81445C57fC438B358F861d3774199cE13c',
}

export const PRODUCT_ADDRS = {
  AAVE_PRODUCT: '0x501ace153Ff22348076FdD236b774F6eb2d55EfB',
  WAAVE_PRODUCT: '0x501Ace6Ff5FAc888273Bc03DC2Bc3aAD7C00fC68',
}

export const TELLER_ADDRS = {
  DAI_TELLER: '0x501AcE5FEe0337e13A442Cb5e15728EE0e8b3F29',
  SOLACE_DAI_SLP_TELLER: '0xbCF4FacfBCECa79fc84627c7E8b5fbEDCE281eCb',
  ETH_TELLER: '0x501ace68E20c29629E690D86E54E79719e2Fc5e8',
  SOLACE_ETH_SLP_TELLER: '0xaff37302e4C9DB772F580A9643812C7a9ad2cf2A',
  USDC_TELLER: '0x501aCE044AE4E11183026659EE3B0E3b0Df04d7F',
  USDT_TELLER: '0x501acE6061D6176Da12FCBa36Bc85B2fc3FFd5e3',
  SOLACE_USDC_SLP_TELLER: '0x501acEb253483BD58773365334DEf095304CddAE',
  SCP_TELLER: '0x501aCE163FfaCDa6584D75b274eD23155BFf4812',
  WBTC_TELLER: '0x501aCE2f3b5B8f645E67556Df77ac4c3081D84C7',
}

export const TOKEN_ADDRS = {
  WA_REGISTRY: '0x166956c3A96c875610DCfb80F228Da0f4e92B73B',
  WA_WETH: '0xe0f1cdB8AC8d75Af103b227Ee0aE7c7fd47A4A83',
  DAI: '0xFf795577d9AC8bD7D90Ee22b6C1703490b6512FD',
  WA_DAI: '0xcc920E61c23f39Ae5AFc7B494E669b975594Eeea',
  USDT: '0x13512979ADE267AB5100878E2e0f485B568328a4',
  WA_USDT: '0x23887f03647282f4E5305e6Cd877842D76De07a1',
  WBTC: '0xD1B98B6607330172f1D991521145A22BCe793277',
  WA_WBTC: '0x8519f664C1a03117C49C0Bd637248B74A0561F9F',
}
